import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CheckAndReturn from "../../utility/CheckAndReturn";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import MeetingCard from "./MeetingCard";
import MeetingTable from "./MeetingTable";
import configServ from "../../services/config";
import MeetingReportPopup from "./MeetingReportPopup";
import LoaderBackdrop from "../../Components/Loader/LoaderBackdrop";
import { toast } from "react-hot-toast";
import Swal from "sweetalert2";
const MeetingLink = () => {
  //#region
  const [openDialog, setOpenDialog] = useState(false);
  const [fetchTableTrue, setFetchtableTrue] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [meetingList, setMeetingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [backDropLoader, setBackDropLoader] = useState(false);
  const { company_id, permissions } = useSelector(
    (state) => state.GlobalVariables
  );

  const [openReport, setOpenReport] = useState(false);
  const [reportData, setReportData] = useState([]);

  const handleClickOpen = () => {
    setOpenDialog(!openDialog);
    setEditData(null);
    setIsEdit(false);
  };

  const handleClose = () => {
    setEditData(null);
    setOpenDialog(false);
    setIsEdit(false);
  };

  //   const fetchTable = () => {
  //     // alert("call");
  //     setFetchtableTrue((prev) => !prev);
  //   };

  const handleEdit = (param) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setOpenDialog(true);
    setEditData(param);
    setIsEdit(true);
  };

  const canCreateAttendance = CheckAndReturn.PermissionHandler(
    "create-attendance",
    permissions
  );

  const fetchMeetings = async () => {
    try {
      setLoading(true);
      const res = await configServ.getMeetings({ company_id: company_id });

      if (res?.status) {
        setMeetingList(res.data);
      } else {
        setMeetingList([]);
      }
    } catch (err) {
      console.error("Fetch meeting error:", err);
      setMeetingList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMeetings();
  }, []);

  const handleSendEmail = async (param) => {
    try {
      setBackDropLoader(true);

      // STEP 1: Check previous reports
      const report = await configServ.getMeetingEmailReports(param.id);

      if (report.data?.length > 0) {
        setBackDropLoader(false);
        // STEP 2: Ask confirmation
        const result = await Swal.fire({
          title: "Emails were already sent!",
          text: "Do you want to send again?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, send again",
          cancelButtonText: "Cancel",
        });

        if (!result.isConfirmed) {
          return;
        }
      }

      // STEP 3: Send again
      const res = await configServ.dispatchEmails(param.id);

      if (res?.status) {
        toast.success("Mail sent!");
      }
    } catch (error) {
      console.error("Fetch meeting error:", error);
    } finally {
      setBackDropLoader(false);
    }
  };

  const handlereport = async (param) => {
    try {
      setBackDropLoader(true);
      const report = await configServ.getMeetingEmailReports(param.id);

      if (report?.status) {
        setReportData(report.data);
        setOpenReport(true);
      }
    } catch (error) {
      console.error("Fetch meeting error:", error);
    } finally {
      setBackDropLoader(false);
    }
  };

  const handleResendEmail = async (param) => {
    setBackDropLoader(true);

    try {
      const result = await configServ.resendEmail(param.id);

      if (result?.status === true) {
        toast.success(result.message || "Email resent successfully!");
      } else {
        toast.error(result?.message || "Failed to resend email");
      }
    } catch (error) {
      console.error("Resend email error:", error);
      toast.error("Something went wrong!");
    } finally {
      setBackDropLoader(false);
    }
  };

  //#endregion
  return (
    <>
      <LoaderBackdrop open={backDropLoader} />
      <CardHeadMenu
        title={"Meeting Link"}
        handlePopup={canCreateAttendance ? handleClickOpen : undefined}
        create={openDialog}
        disabled={!canCreateAttendance} // ✅ if CardHeadMenu supports disabled prop
      />

      {openDialog && (
        <MeetingCard
          handleClose={handleClose}
          fetchTable={fetchMeetings}
          editData={editData}
          setEditData={setEditData}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      )}
      <MeetingTable
        data={meetingList}
        loading={loading}
        onEdit={(row) => handleEdit(row)}
        onSendEmail={(row) => handleSendEmail(row)}
        onReport={(row) => handlereport(row)}
      />
      <MeetingReportPopup
        open={openReport}
        setOpen={setOpenReport}
        reportData={reportData}
        handleResendEmail={(row) => handleResendEmail(row)}
      />
    </>
  );
};

export default MeetingLink;
